import React from 'react'
import { NarrativeBlock as NarrativeBlockData } from '@marketing-milk/interfaces'
import { SurfacePalette } from '../../tokens'
import { NarrativeEditor } from './NarrativeEditor'
import { SectionCard } from './SectionCard'
import { NarrativeBuiltInSectionKey } from '../sections'

interface Props {
  palette: SurfacePalette
  sectionKey: NarrativeBuiltInSectionKey
  label: string
  packetID: number
  narrative: NarrativeBlockData[]
}

export const NarrativeSection = ({ palette, sectionKey, label, packetID, narrative }: Props) => (
  <SectionCard
    palette={palette}
    sectionKey={sectionKey}
    title={label}
    commentAnchor={{ type: 'section', id: `${packetID}:${sectionKey}`, label }}
  >
    <NarrativeEditor
      palette={palette}
      sectionKey={sectionKey}
      label={label}
      packetID={packetID}
      narrative={narrative}
    />
  </SectionCard>
)
